
import * as imageProviderRuntime$_XygA4rv_7Etjkx7MCCuRUjWwdORZPDhYz4vtTtqYJk from '/app/app/imageProvider.ts'
import * as videoThumbnailRuntime$_45BpETksizFbMZ_5C84uN8D5sHon_a_45rMySsIcn8yVc from '/app/app/videoThumbnailProvider.ts'
import * as pdfThumbnailRuntime$_XygA4rv_7Etjkx7MCCuRUjWwdORZPDhYz4vtTtqYJk from '/app/app/imageProvider.ts'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "imageProvider",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['imageProvider']: { provider: imageProviderRuntime$_XygA4rv_7Etjkx7MCCuRUjWwdORZPDhYz4vtTtqYJk, defaults: undefined },
  ['videoThumbnail']: { provider: videoThumbnailRuntime$_45BpETksizFbMZ_5C84uN8D5sHon_a_45rMySsIcn8yVc, defaults: undefined },
  ['pdfThumbnail']: { provider: pdfThumbnailRuntime$_XygA4rv_7Etjkx7MCCuRUjWwdORZPDhYz4vtTtqYJk, defaults: {"basePath":"/api/thumbnail/pdf"} }
}
        